import validate from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-contract": () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/middleware/checkContract.js"),
  "is-logged-in": () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/middleware/isLoggedIn.js"),
  "is-logged-out": () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/middleware/isLoggedOut.js")
}